module.exports = __webpack_public_path__ + "assets/site-kit.ee081c3b.svg";